<template>
<div class="page page_dingzhi page_dingzhiDetail public">
	<van-notice-bar  left-icon="volume-o"  text="当前页面内容为订单快照，买卖双方和平台再发生交易争议时，该页面作为判定依据。"/>
    <div class="banner" v-if="info && info.attrShow">
		<van-swipe class="my-swipe detail_swipe" :autoplay="bannerTime">
            <van-swipe-item :show-indicators="false" :loop="false" v-if="info.video_type==0&&info.other_video_url">
				<div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
			</van-swipe-item>
            <van-swipe-item :show-indicators="false" :loop="false" v-else-if="info.video_type==1&&info.video_url">
				<div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
			</van-swipe-item>
			<van-swipe-item :show-indicators="false" :loop="false" v-for="(img,index) in info.attrShow" :key="index">
				<van-image fit="cover" class="banner_tu" :show-error="false" :show-loading="false" :src="imageUrl+img" />
			</van-swipe-item>
		</van-swipe>
	</div>
	<div class="dingzhi_nr" v-if="info != null">
		<div class="title">{{ info.made_title }}</div>  
		<div class="price">应付款：¥<span class="jiage">{{ info.order.total_prices }}</span></div>
		<div class="price">预付款：¥<span class="jiage">{{ info.order.deposit }}</span></div>
		<div class="price">尾款：¥<span class="jiage">{{ info.order.final_payment }}</span></div>
		<div class="desc">{{ info.descript }}</div>
	</div>
	<div class="info" v-if="info">
		<div class="jieshao" v-html="info.content"></div>
	</div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../../.././vuex/bridge.js'
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
			orderId: this.$route.query.orderId,
            info: null,
			playerId: 'aliplayer_' +
                    Math.random()
                        .toString(36)
                        .substr(2),
			instance: null,
			playStyle: {
				width: '100%',
				height: '6.57rem',
				display: 'none',
			},
            playerId: 'aliplayer_' +
                Math.random()
                .toString(36)
				.substr(2),
			player: null,   // 初始化的播放器
			bannerTime: '3000',
            showImage: false,
            position: 0,
            isEnd: false
        };
    },
	// created
    created: function () {
        var that = this;
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '订单快照',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getDetail()
                } else {
                    this.token = ''
                    this.getDetail()
                }

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.info.descript ? that.info.descript : '',
                        url: url,
                        platFormType: '',
                        image: that.info.attrShow ? that.$publicData.domain + that.info.attrShow[0] : that.$publicData.domain + that.$publicData.shareDefaultIcon,
                        isMiniProgram: "1",
                        miniUserName: that.$publicData.miniUserName,
                        path: 'pages/detail/index?id='+that.id
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
            this.getDetail()
        }
	},
    methods: {
        getDetail() {
            var that = this
            var params = {
                order_id: this.orderId,
                token: this.token
            }
            this.$api.dingzhi.orderPhoto(params).then(res => {
                if (res.code == 200) {
                    var info = res.result
					// 初始化播放器
					if(info.video_type==0 && info.other_video_url){
                        setTimeout(() => {
                            that.setPlayer()
                        }, 500);
						
                        that.bannerTime = ''
					} else if (info.video_type==1 && info.video_url) {
                        setTimeout(() => {
                            that.setPlayer()
                        }, 500);
                        // that.setPlayer()
                        that.bannerTime = ''
                    };
					// 处理富文本
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
					this.info = info;
                }else{
					this.$toast(res.message);
				}
            })
        },
		// 播放器
		setPlayer() {
			var that = this
			console.log('调了吗====',that.playerId)
			console.log('=====',$('#'+that.playerId))
            that.playStyle.display = 'block';
            var videoUrl = ''
            if(that.info.video_type==0 && that.info.other_video_url){
				videoUrl = that.info.other_video_url
			} else if (that.info.video_type==1 && that.info.video_url) {
                videoUrl = that.$publicData.domain + '/' + that.info.video_url
            }
            that.instance = new Aliplayer({
                    id: that.playerId,
                    source: videoUrl,
                    width: '100%',
                    height: that.playStyle.height,
					autoplay: true, // 是否自动播放
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    // controlBarVisibility: "hover",
                    // useH5Prism: true,
                    skinLayout: [{
                            name: "bigPlayButton",
                            align: "blabs",
                            x: 30,
                            y: 80
                        },
                        {
                            name: "H5Loading",
                            align: "cc"
                        },
                        {
                            name: "infoDisplay"
                        },
                        {
                            name: "tooltip",
                            align: "blabs",
                            x: 0,
                            y: 56
                        },
                        {
                            name: "thumbnail"
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            "children": [
                                // {
                                //     "name": "progress",
                                //     "align": "blabs",
                                //     "x": 0,
                                //     "y": 44
                                // },
                                // {
                                //     "name": "playButton",
                                //     "align": "tl",
                                //     "x": 15,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "timeDisplay",
                                //     "align": "tl",
                                //     "x": 10,
                                //     "y": 7
                                // },
                                // {
                                //     "name": "fullScreenButton",
                                //     "align": "tr",
                                //     "x": 10,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "volume",
                                //     "align": "tr",
                                //     "x": 5,
                                //     "y": 10
                                // }
                            ]
                        }
                    ],
                    x5LandscapeAsFullScreen: false,
                    // x5_type:'h5',
                    showBarTime: 5000,
                    // controlBarVisibility: "always",
                    // x5_fullscreen: true,
                    x5_video_position: "bottom",
                    // "x5_orientation":"landscape",
                },
                function (player) {
                    that.player = player;
                    console.log('The player is created');
                    // $('.prism-volume').before("<i class='control_btn'></i>");
                    $("video").attr('x5-video-player-type', 'h5');
                    // $('.control_btn').on('click', function () {
                    //     if (!$('.prism-player').hasClass('fullScreen')) {
                    //         $('.prism-player').addClass('fullScreen');
                    //         $('.living_tabs').addClass('fullScreen');
                    //     } else {
                    //         $('.prism-player').removeClass('fullScreen');
                    //         $('.living_tabs').removeClass('fullScreen');
                    //     }
                    // });
                    player.on("error", function (e) {
                        $(".prism-ErrorMessage").hide();
                        player.show_video = true;
                    })
                    player.on("ended", function (e) {
                        
                        player.play()
                    })
                    // player.on("ended", function (e) {
                        
                    //     player.play() = true;
                    // });
                }
            );
		},
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15'
		getTimes(strdate){
			var arr = strdate.split(/[- : \/]/);
			var date = new Date(arr[0], arr[1] - 1, arr[2],24,0,0);
			return date;
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
